/**
 * Shared plan-access helpers for expiry-aware UI gating.
 *
 * @module planAccess
 */

import type { CurrentPlan } from '@/lib/planApi';

export function requiresRenewal(plan: CurrentPlan | null | undefined): boolean {
  return plan?.requires_renewal === true;
}

export function canStartSimulation(
  plan: CurrentPlan | null | undefined,
  isAdmin: boolean = false,
): boolean {
  if (isAdmin) return true;
  return Boolean(plan) && !requiresRenewal(plan);
}

export const SIMULATION_RENEWAL_BLOCK_MESSAGE =
  'Your pass expired. Renew your plan to start or resume simulations.';

export const SIMULATION_RENEWAL_NAV_HINT =
  'Renew your pass to access exam simulations';
